import { RouterProvider } from '@tanstack/react-router'
import { useState } from 'react'

import { Providers } from './providers'
import { createAppRouter } from './router'

export function App() {
  // One router per mount. Rebuilding it on a render would throw away the
  // navigation history and remount every route.
  const [router] = useState(createAppRouter)

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  )
}
